import { useEffect, useState } from 'react'

const APP = 'Clearpol Compliance'

/** Sets the browser tab title: "<page> | Clearpol Compliance". */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title) document.title = `${title} | ${APP}`
  }, [title])
}

export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return v
}
